import * as moment from 'moment';

const Timestamp = (props) => {
    const id = props.createdId;
    const firstName = props.firstName;
    const lastName = props.lastName;
    const createdDate = props.createdDate;

    return (
        <>
            {id && <>{`${firstName} ${lastName}`}&emsp;</>}{' '}
            {createdDate &&
                moment.unix(createdDate).local().format('MMM D, YYYY LT')}
        </>
    );
};

export default Timestamp;
